<div class="root relative z-1 max-w-144 mx-auto overflow-hidden">
  <router-outlet />

  <img src="/images/bottom-gradient.webp" class="w-full h-auto fixed bottom-0 left-0 -z-1 pointer-events-none" width="390" height="400" alt="Gradient">
</div>
@if (maintenancePopup(); as popup) {
  <app-maintenance-popup
    [popup]="popup"
    [retrying]="maintenanceRetrying()"
    (retryRequested)="retryMaintenance()"
    (dismissRequested)="dismissMaintenance()" />
}
@if (isLoading()) {
  <app-preloader />
}
